import { useUserStore } from "~/store/auth";
import { useMasters } from "~/store/masters";

export const ORGANIZATIONS = {
  WIND: {
    ORGDESC_ES: "Eólica",
    ORGDESC_EN: "Wind",
  },
  BIOM: {
    ORGDESC_ES: "Biomasa",
    ORGDESC_EN: "Biomass",
  },
  HID: {
    ORGDESC_ES: "Hidráulica",
    ORGDESC_EN: "Hydraulics",
  },
  PV: {
    ORGDESC_ES: "Fotovoltaica",
    ORGDESC_EN: "Photovoltaic",
  },
  TERM: {
    ORGDESC_ES: "Termosolar",
    ORGDESC_EN: "Thermal",
  },
  BESS: {
    ORGDESC_ES: "Almacenamiento",
    ORGDESC_EN: "Battery Energy Storage System",
  },
  GD: {
    ORGDESC_ES: "Generación distribuida",
    ORGDESC_EN: "Distributed generation",
  },
  MET: {
    ORGDESC_ES: "Meteo",
    ORGDESC_EN: "Meteo",
  },
};

// composables/useSortMates.js
export function useSortMates() {
  const sortMates = (data) => {
    const loggedGroup = useUserStore().profile?.DEFAULTPERSONGROUP;

    const mates = data.map((mate) => ({
      ...mate,
      SEARCH: `${mate.LABORID} ${
        mate.DEFAULTPERSONGROUP ? " · " + mate.DEFAULTPERSONGROUP : ""
      } · ${mate.FIRSTNAME || ""} ${mate?.LASTNAME || ""} ${
        mate.PERSONGROUPS_OBJ
          ? " · " + Object.values(mate.PERSONGROUPS_OBJ).join(", ")
          : ""
      }`,
    }));

    const sameGroup = mates.filter(
      (m) =>
        m.PERSONGROUPS_OBJ && loggedGroup && loggedGroup in m.PERSONGROUPS_OBJ
    );
    const diffGroup = mates.filter(
      (m) => m.PERSONGROUPS_OBJ && !(loggedGroup in m.PERSONGROUPS_OBJ)
    );

    const emptyGroup = mates.filter(
      (m) => !m.PERSONGROUPS_OBJ || m.PERSONGROUPS_OBJ === ""
    );

    const sortByName = (a, b) =>
      `${a.FIRSTNAME || ""} ${a.LASTNAME || ""}`
        .toLowerCase()
        .localeCompare(
          `${b.FIRSTNAME || ""} ${b.LASTNAME || ""}`.toLowerCase()
        );

    sameGroup.sort(sortByName);
    diffGroup.sort(sortByName);
    emptyGroup.sort(sortByName);

    return [...sameGroup, ...diffGroup, ...emptyGroup];
  };

  const sortPlanlaborByMates = (data) => {
    const uniqueLaborCodes = [...new Set(data.map((p) => p.LABORCODE))];

    return sortMates(
      uniqueLaborCodes
        .map((code) => useMasters().mates.list.find((m) => m.LABORID === code))
        .filter(Boolean)
    );
  };

  const sortLaborCodesByMates = (laborCodes) => {
    const uniqueLaborCodes = [...new Set(laborCodes)];
    const sortedMates = sortMates(
      uniqueLaborCodes.map((code) => {
        const mateFound = useMasters().mates.list.find(
          (m) => m.LABORID === code
        );

        // Si existe, lo devolvemos tal cual
        if (mateFound) return mateFound;

        // Si NO existe, creamos un objeto con la estructura mínima necesaria
        // para que no rompa el resto de la aplicación
        return {
          PERSONID: code,
          LABORID: code,
          IDTDOC_USER: "",
          ORGID: "",
          CRAFT: "",
          SUBCONTRACTOR: "",
          FIRSTNAME: "",
          LASTNAME: "",
          DEFAULTPERSONGROUP: "",
          ROWSTAMP: "",
          PERSONGROUPS: "",
          PERSONGROUPS_OBJ: {},
        };
      })
    );
    return sortedMates.map((mate) => mate.LABORID);
  };

  /**
   * NUEVA FUNCIÓN: Ordena un objeto cuyas llaves son LABORCODEs
   * @param {Object} dataObject - El objeto tipo { "ACACHO": [...], "ARAYO": [...] }
   */
  const sortDataObjectByMates = (dataObject) => {
    // 1. Obtenemos las llaves actuales del objeto
    const keys = Object.keys(dataObject);

    // 2. Reutilizamos tu lógica para obtener el orden correcto de esas llaves
    const sortedKeys = sortLaborCodesByMates(keys);

    // 3. Reconstruimos el objeto insertando las llaves en el nuevo orden
    return sortedKeys.reduce((acc, key) => {
      acc[key] = dataObject[key];
      return acc;
    }, {});
  };

  return {
    sortMates,
    sortPlanlaborByMates,
    sortLaborCodesByMates,
    sortDataObjectByMates, // <--- Exportada
  };
}
